import type { JSX } from 'react';
import { useQuery } from '@tanstack/react-query';

import { listTenants } from '@/features/tenants/api/tenants.graphql';

import styles from './UsabilityFilters.module.scss';

export function TenantSelector({
  value,
  onChange,
}: {
  value: string;
  onChange: (tenantId: string) => void;
}): JSX.Element {
  const { data } = useQuery({
    queryKey: ['platform-tenants-selector'],
    queryFn: () => listTenants({ take: 100 }),
  });

  const tenants = data?.edges ?? [];

  return (
    <select
      className={styles.filterSelect}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Selecciona un tenant…</option>
      {tenants.map((tenant) => (
        <option key={tenant.id} value={tenant.id}>
          {tenant.name}
        </option>
      ))}
    </select>
  );
}
